import detach from "./detach_icon_24px.png";

export const DetachIcon = () => <img src={detach} alt="Detach icon" />;
